export function TalentFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/talent-filled.svg'"></ng-include>`
    }
}